var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHeart = function SvgHeart(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.232 12.294 6.772 6.095 6.772-6.095c1.629-1.63 1.276-4.055-.142-5.46-.696-.69-1.617-1.093-2.637-1.021s-2.24.627-3.502 2.05a.656.656 0 0 1-.982 0C10.251 6.44 9.03 5.883 8.007 5.809c-1.024-.074-1.947.329-2.643 1.015-1.42 1.4-1.775 3.825-.132 5.47m6.772-5.809c-1.28-1.258-2.619-1.88-3.903-1.973-1.449-.104-2.731.474-3.66 1.39-1.826 1.802-2.395 5.066-.124 7.322l.024.022 7.224 6.502c.25.225.629.225.878 0l7.224-6.502.024-.022c2.259-2.245 1.687-5.508-.133-7.312-.926-.917-2.206-1.498-3.654-1.396-1.283.09-2.62.71-3.9 1.97Z",
    clipRule: "evenodd"
  })));
};
export { SvgHeart as ReactComponent };
export default __webpack_public_path__ + "static/media/heart.50f237322074e0e1db0104946223daa7.svg";